import { CssBaseline, ThemeProvider } from "@mui/material";
import "./App.css";
import { theme } from "./theme";
import MainRouter from "./Router/MainRouter";
import store from "./redux/stores/store";
import { Provider } from "react-redux";
import { useEffect } from "react";
import { getTenantCustomNameAPI } from "./redux/api/common/CustomDomainApi";
import Cookies from "js-cookie";
import Websocket from "./socket/Websocket";
import DesktopNotificationStack from "./components/admin/DesktopNotificationStack";
// import { listenToMessages, requestPermissionAndGetToken } from "./notifications";


function App() {

  const fetchCustomDomain = async () => {
    // debugger
    const hostname = window.location.hostname;
    const res = await getTenantCustomNameAPI(hostname);
    console.log("custom domain response");
    console.log(res)
    console.log(res?.data)
    if (res?.data?.response?.tenantCode)
      Cookies.set("custom_tenant", res?.data?.response?.tenantCode, {
        path: "/",
        domain: hostname,
        // domain: "localhost",
        secure: true,
        sameSite: "Strict",
      });
    window.location.reload();
  };

  useEffect(() => {

    const customTenant = Cookies.get("custom_tenant");
    console.log("custom tenant from cookie:", window.location.hostname);
    if (
      !(
        window.location.hostname.includes("qabranch.d1tx7ryv7rtvh6.amplifyapp.com") ||
        window.location.hostname.includes("padami.app") ||
        customTenant ||
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("admin.printurmemories.in")
      )
    ) {
      // fetchCustomDomain();
      console.log("No custom domain");
    }
  }, []);

  // useEffect(() => {
  //   const initNotifications = async () => {
  //     const token = await requestPermissionAndGetToken();

  //     if (token) {
  //       // Send token to your backend
  //       // await fetch("/api/save-token", {
  //       //   method: "POST",
  //       //   headers: { "Content-Type": "application/json" },
  //       //   body: JSON.stringify({ token }),
  //       // });
  //       // console
  //     }
  //   };

  //   initNotifications();
  //   listenToMessages();
  // }, []);


  return (
    <div>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Websocket />
          <DesktopNotificationStack />
          <CssBaseline />
          <MainRouter></MainRouter>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default App;
